import React, { FC } from "react";
import { Flex } from "../../atoms/flex";
import { Icon, IconType } from "../../atoms/icon";
import { Title } from "../../atoms/title";
import "./savings-card.css";
import { SavingsCardSkeleton } from "./savings-card.skeleton";

interface SavingsCardProps {
  icon?: IconType;
  value?: string | number | null | undefined;
  text?: string;
  unit?: string;
  noUnitSpace?: boolean;
  className?: string;
  isLoading?: boolean;
  tag?: "h1" | "h2" | "h3" | "h4" | "h5";
}

/**
 * Savings card component
 */
export const SavingsCard: FC<SavingsCardProps> = ({
  icon,
  value,
  text,
  unit,
  noUnitSpace,
  className,
  isLoading,
  tag = "h3",
}) => {
  return (
    <Flex className={`SavingsCard ${className || ""}`}>
      <Icon type={icon} size={text ? "s" : "m"} />
      {isLoading ? (
        <SavingsCardSkeleton />
      ) : (
        <>
          <Title
            text={`${value || value === 0 ? value : ""}${
              noUnitSpace ? "" : " "
            }${unit || ""}`}
            tag={tag}
          />
          {text && <Title tag="h4" text={text || ""} />}
        </>
      )}
    </Flex>
  );
};
